import { FldrObject } from '../models/fldrobject';
import { ObjectWrapper } from './object.wrapper';
import { CommonEnums } from '../common.enums';
import { UDFGridObject } from '../models/beans/udfgridobject';
import { StreamGridObject } from '../models/beans/streamgridobject';
import { ConnObject } from '../models/beans/connobject';
import { DObjObject } from '../models/beans/dobjobject';
import { DesignGridObject } from '../models/beans/designgridobject';
import { SeqGridObject } from '../models/beans/seqgridobject';
import { DBFunGridObject } from '../models/beans/dbfungridobject';
import { Param } from '../models/domain/param';
import { RepFolderWrapper } from 'src/app/modules/parameter/repfolder.wrapper';

export class FldrObjectWrapper {
    fldrObject: FldrObject;
    fldrObjectCopy: FldrObject;

    objectWrappersMap: Map<number, ObjectWrapper>;
    deletedObjectWrappers: Array<ObjectWrapper>;

    //grid objects
    connObjects: Array<ConnObject>;
    dObjObjects: Array<DObjObject>;
    dataFlowGridObjects: Array<DesignGridObject>;
    dataSubFlowGridObjects: Array<DesignGridObject>;
    dataStreamGridObjects: Array<DesignGridObject>;
    dataConnectGridObjects: Array<DesignGridObject>;
    streamGridObjects: Array<StreamGridObject>;
    seqGridObjects: Array<SeqGridObject>;
    dBFunGridObjects: Array<DBFunGridObject>;
    uDFGridObjects: Array<UDFGridObject>;

    hasStudioPrivilege: boolean;

    constructor(fldrObjectTmp: FldrObject) {
        this.fldrObject = fldrObjectTmp;
        this.fldrObjectCopy = new FldrObject();

        this.objectWrappersMap = new Map<number, ObjectWrapper>();
        this.deletedObjectWrappers = new Array<ObjectWrapper>();

        this.connObjects = new Array<ConnObject>();
        this.dObjObjects = new Array<DObjObject>();
        this.dataFlowGridObjects = new Array<DesignGridObject>();
        this.dataSubFlowGridObjects = new Array<DesignGridObject>();
        this.dataStreamGridObjects = new Array<DesignGridObject>();
        this.dataConnectGridObjects = new Array<DesignGridObject>();
        this.streamGridObjects = new Array<StreamGridObject>();
        this.seqGridObjects = new Array<SeqGridObject>();
        this.dBFunGridObjects = new Array<DBFunGridObject>();
        this.uDFGridObjects = new Array<UDFGridObject>();

        this.hasStudioPrivilege = false;
    }

    isModified(): boolean {
        return false;
    }

    get fldr_Id(): number {
        return this.fldrObject.fldr.fldr_Id;
    }

    get change_Ind(): string {
        return this.fldrObject.fldr.change_Ind;
    }

    clear(): void {
        this.objectWrappersMap.clear();
        this.fldrObject.clear();
        this.spliceAllGridObjects();
    }

    spliceObjectWrappers(obj_Ids: Array<number>): void {
        for (let i: number = 0; i < obj_Ids.length; i++) {
            let objectWrapper: ObjectWrapper = this.objectWrappersMap.get(obj_Ids[i]);
            if (!objectWrapper) continue;

            this.fldrObject.splice(objectWrapper.object, objectWrapper.obj_Id, objectWrapper.obj_Cd);
            this.objectWrappersMap.delete(objectWrapper.obj_Id);
        }
    }

    spliceObjectWrapper(obj_Id: number): void {
        let objectWrapper: ObjectWrapper = this.objectWrappersMap.get(obj_Id);
        if (!objectWrapper) return;

        this.fldrObject.splice(objectWrapper.object, objectWrapper.obj_Id, objectWrapper.obj_Cd);
        this.objectWrappersMap.delete(objectWrapper.obj_Id);
    }

    getDeletedObjectWrapper(obj_Id: number): ObjectWrapper {
        for (let i: number = 0; i < this.deletedObjectWrappers.length; i++) {
            if (this.deletedObjectWrappers[i].obj_Id == obj_Id) {
                return this.deletedObjectWrappers[i];
            }
        }

        return null;
    }

    spliceDeletedObjectWrapper(obj_Id: number): ObjectWrapper {
        for (let i: number = 0; i < this.deletedObjectWrappers.length; i++) {
            if (this.deletedObjectWrappers[i].obj_Id == obj_Id) {
                let deletedObjectWrappers: Array<ObjectWrapper> = this.deletedObjectWrappers.splice(i, 1);
                if (deletedObjectWrappers.length > 0) {
                    return deletedObjectWrappers[i];
                }
                break;
            }
        }

        return null;
    }

    /****************************************/
    /************* GRID OBJECTS *************/
    /****************************************/
    getGridObject(obj_Id: number, obj_Cd: string, reusableFlag: string = CommonEnums.reusableFlag.NO,
        streamingFlg: string = CommonEnums.streamingFlg.NO): any {
        switch (obj_Cd) {
            case CommonEnums.codes.REPCONN:
                for (let i: number = 0; i < this.connObjects.length; i++) {
                    if (this.connObjects[i].obj_Id == obj_Id) {
                        return this.connObjects[i];
                    }
                }
                break;
            case CommonEnums.codes.DATAOBJECT:
                for (let i: number = 0; i < this.dObjObjects.length; i++) {
                    if (this.dObjObjects[i].obj_Id == obj_Id) {
                        return this.dObjObjects[i];
                    }
                }
                break;

            case CommonEnums.codes.DESIGN:
                if (reusableFlag == CommonEnums.reusableFlag.YES) {
                    for (let i: number = 0; i < this.dataSubFlowGridObjects.length; i++) {
                        if (this.dataSubFlowGridObjects[i].obj_Id == obj_Id) {
                            return this.dataSubFlowGridObjects[i];
                        }
                    }
                    break;
                }

                if (streamingFlg == CommonEnums.streamingFlg.YES) {
                    for (let i: number = 0; i < this.dataStreamGridObjects.length; i++) {
                        if (this.dataStreamGridObjects[i].obj_Id == obj_Id) {
                            return this.dataStreamGridObjects[i];
                        }
                    }
                    break;
                }

                if (streamingFlg == CommonEnums.streamingFlg.DATACONNECT) {
                    for (let i: number = 0; i < this.dataConnectGridObjects.length; i++) {
                        if (this.dataConnectGridObjects[i].obj_Id == obj_Id) {
                            return this.dataConnectGridObjects[i];
                        }
                    }
                    break;
                }

                for (let i: number = 0; i < this.dataFlowGridObjects.length; i++) {
                    if (this.dataFlowGridObjects[i].obj_Id == obj_Id) {
                        return this.dataFlowGridObjects[i];
                    }
                }
                break;
            case CommonEnums.codes.STREAM:
                for (let i: number = 0; i < this.streamGridObjects.length; i++) {
                    if (this.streamGridObjects[i].obj_Id == obj_Id) {
                        return this.streamGridObjects[i];
                    }
                }
                break;
            case CommonEnums.codes.DBSEQ:
                for (let i: number = 0; i < this.seqGridObjects.length; i++) {
                    if (this.seqGridObjects[i].obj_Id == obj_Id) {
                        return this.seqGridObjects[i];
                    }
                }
                break;
            case CommonEnums.codes.DBFUN:
                for (let i: number = 0; i < this.dBFunGridObjects.length; i++) {
                    if (this.dBFunGridObjects[i].obj_Id == obj_Id) {
                        return this.dBFunGridObjects[i];
                    }
                }
                break;
            case CommonEnums.codes.UDF:
                for (let i: number = 0; i < this.uDFGridObjects.length; i++) {
                    if (this.uDFGridObjects[i].obj_Id == obj_Id) {
                        return this.uDFGridObjects[i];
                    }
                }
                break;
        }

        return null;
    }

    getGridObjectIndex(obj_Id: number, obj_Cd: string, reusableFlag: string = CommonEnums.reusableFlag.NO,
        streamingFlg: string = CommonEnums.streamingFlg.NO): number {
        switch (obj_Cd) {
            case CommonEnums.codes.REPCONN:
                for (let i: number = 0; i < this.connObjects.length; i++) {
                    if (this.connObjects[i].obj_Id == obj_Id) {
                        return i;
                    }
                }
                break;
            case CommonEnums.codes.DATAOBJECT:
                for (let i: number = 0; i < this.dObjObjects.length; i++) {
                    if (this.dObjObjects[i].obj_Id == obj_Id) {
                        return i;
                    }
                }
                break;
            case CommonEnums.codes.DESIGN:
                if (reusableFlag == CommonEnums.reusableFlag.YES) {
                    for (let i: number = 0; i < this.dataSubFlowGridObjects.length; i++) {
                        if (this.dataSubFlowGridObjects[i].obj_Id == obj_Id) {
                            return i;
                        }
                    }
                    break;
                }

                if (streamingFlg == CommonEnums.streamingFlg.YES) {
                    for (let i: number = 0; i < this.dataStreamGridObjects.length; i++) {
                        if (this.dataStreamGridObjects[i].obj_Id == obj_Id) {
                            return i;
                        }
                    }
                    break;
                }

                if (streamingFlg == CommonEnums.streamingFlg.DATACONNECT) {
                    for (let i: number = 0; i < this.dataConnectGridObjects.length; i++) {
                        if (this.dataConnectGridObjects[i].obj_Id == obj_Id) {
                            return i;
                        }
                    }
                    break;
                }
                for (let i: number = 0; i < this.dataFlowGridObjects.length; i++) {
                    if (this.dataFlowGridObjects[i].obj_Id == obj_Id) {
                        return i;
                    }
                }

                break;
            case CommonEnums.codes.STREAM:
                for (let i: number = 0; i < this.streamGridObjects.length; i++) {
                    if (this.streamGridObjects[i].obj_Id == obj_Id) {
                        return i;
                    }
                }
                break;
            case CommonEnums.codes.DBSEQ:
                for (let i: number = 0; i < this.seqGridObjects.length; i++) {
                    if (this.seqGridObjects[i].obj_Id == obj_Id) {
                        return i;
                    }
                }
                break;
            case CommonEnums.codes.DBFUN:
                for (let i: number = 0; i < this.dBFunGridObjects.length; i++) {
                    if (this.dBFunGridObjects[i].obj_Id == obj_Id) {
                        return i;
                    }
                }
                break;
            case CommonEnums.codes.UDF:
                for (let i: number = 0; i < this.uDFGridObjects.length; i++) {
                    if (this.uDFGridObjects[i].obj_Id == obj_Id) {
                        return i;
                    }
                }
                break;
        }

        return -1;
    }

    spliceGridObject(obj_Id: number, obj_Cd: string, reusableFlag: string = CommonEnums.reusableFlag.NO,
        streamingFlg: string = CommonEnums.streamingFlg.NO): Array<any> {
        switch (obj_Cd) {
            case CommonEnums.codes.REPCONN:
                for (let i: number = 0; i < this.connObjects.length; i++) {
                    if (this.connObjects[i].obj_Id == obj_Id) {
                        return this.connObjects.splice(i, 1);
                    }
                }
                break;

            case CommonEnums.codes.DATAOBJECT:
                for (let i: number = 0; i < this.dObjObjects.length; i++) {
                    if (this.dObjObjects[i].obj_Id == obj_Id) {
                        return this.dObjObjects.splice(i, 1);
                    }
                }
                break;
            case CommonEnums.codes.DESIGN:
                if (reusableFlag == CommonEnums.reusableFlag.YES) {
                    for (let i: number = 0; i < this.dataSubFlowGridObjects.length; i++) {
                        if (this.dataSubFlowGridObjects[i].obj_Id == obj_Id) {
                            return this.dataSubFlowGridObjects.splice(i, 1);
                        }
                    }
                    break;
                }
                if (streamingFlg == CommonEnums.streamingFlg.YES) {
                    for (let i: number = 0; i < this.dataStreamGridObjects.length; i++) {
                        if (this.dataStreamGridObjects[i].obj_Id == obj_Id) {
                            return this.dataStreamGridObjects.splice(i, 1);
                        }
                    }
                    break;
                }
                if (streamingFlg == CommonEnums.streamingFlg.DATACONNECT) {
                    for (let i: number = 0; i < this.dataConnectGridObjects.length; i++) {
                        if (this.dataConnectGridObjects[i].obj_Id == obj_Id) {
                            return this.dataConnectGridObjects.splice(i, 1);
                        }
                    }
                    break;
                }

                for (let i: number = 0; i < this.dataFlowGridObjects.length; i++) {
                    if (this.dataFlowGridObjects[i].obj_Id == obj_Id) {
                        return this.dataFlowGridObjects.splice(i, 1);
                    }
                }
                break;
            case CommonEnums.codes.STREAM:
                for (let i: number = 0; i < this.streamGridObjects.length; i++) {
                    if (this.streamGridObjects[i].obj_Id == obj_Id) {
                        return this.streamGridObjects.splice(i, 1);
                    }
                }
                break;
            case CommonEnums.codes.DBSEQ:
                for (let i: number = 0; i < this.seqGridObjects.length; i++) {
                    if (this.seqGridObjects[i].obj_Id == obj_Id) {
                        return this.seqGridObjects.splice(i, 1);
                    }
                }
                break;
            case CommonEnums.codes.DBFUN:
                for (let i: number = 0; i < this.dBFunGridObjects.length; i++) {
                    if (this.dBFunGridObjects[i].obj_Id == obj_Id) {
                        return this.dBFunGridObjects.splice(i, 1);
                    }
                }
                break;
            case CommonEnums.codes.UDF:
                for (let i: number = 0; i < this.uDFGridObjects.length; i++) {
                    if (this.uDFGridObjects[i].obj_Id == obj_Id) {
                        return this.uDFGridObjects.splice(i, 1);
                    }
                }
                break;
        }

        return new Array<any>();
    }

    spliceGridObjects(obj_Cd: string, reusableFlag: string = CommonEnums.reusableFlag.NO,
        streamingFlg: string = CommonEnums.streamingFlg.NO): void {
        switch (obj_Cd) {
            case CommonEnums.codes.REPCONN:
                this.connObjects.splice(0, this.connObjects.length);
                break;
            case CommonEnums.codes.DATAOBJECT:
                this.dObjObjects.splice(0, this.dObjObjects.length);
                break;
            case CommonEnums.codes.DESIGN:
                if (reusableFlag == CommonEnums.reusableFlag.YES) {
                    this.dataSubFlowGridObjects.splice(0, this.dataSubFlowGridObjects.length);
                    break;
                }

                if (streamingFlg == CommonEnums.streamingFlg.YES) {
                    this.dataStreamGridObjects.splice(0, this.dataStreamGridObjects.length);
                    break;
                }

                if (streamingFlg == CommonEnums.streamingFlg.DATACONNECT) {
                    this.dataConnectGridObjects.splice(0, this.dataConnectGridObjects.length);
                    break;
                }

                this.dataFlowGridObjects.splice(0, this.dataFlowGridObjects.length);
                break;
            case CommonEnums.codes.STREAM:
                this.streamGridObjects.splice(0, this.streamGridObjects.length);
                break;
            case CommonEnums.codes.DBSEQ:
                this.seqGridObjects.splice(0, this.seqGridObjects.length);
                break;
            case CommonEnums.codes.DBFUN:
                this.dBFunGridObjects.splice(0, this.dBFunGridObjects.length);
                break;
            case CommonEnums.codes.UDF:
                this.uDFGridObjects.splice(0, this.uDFGridObjects.length);
                break;
        }
    }

    spliceAllGridObjects(): void {
        this.connObjects.splice(0, this.connObjects.length);
        this.dObjObjects.splice(0, this.dObjObjects.length);
        this.dataFlowGridObjects.splice(0, this.dataFlowGridObjects.length);
        this.dataSubFlowGridObjects.splice(0, this.dataSubFlowGridObjects.length);
        this.dataStreamGridObjects.splice(0, this.dataStreamGridObjects.length);
        this.dataConnectGridObjects.splice(0, this.dataConnectGridObjects.length);
        this.streamGridObjects.splice(0, this.streamGridObjects.length);
        this.seqGridObjects.splice(0, this.seqGridObjects.length);
        this.dBFunGridObjects.splice(0, this.dBFunGridObjects.length);
        this.uDFGridObjects.splice(0, this.uDFGridObjects.length);
    }

    getUnsavedProjectParams(fldr_Id: number = -1): Array<Param> {
        let unsavedParams = new Array<Param>();
        if (fldr_Id == -1) {
            return unsavedParams;
        }

        let repFolderWrapper: RepFolderWrapper = this.objectWrappersMap.get(fldr_Id) as RepFolderWrapper;
        return unsavedParams = this.fldrObject.getUnsavedProjectParams(repFolderWrapper.repFolder.params, repFolderWrapper.objectCopy.params)
    }

    getUnsavedObjectsInOrder() {
        let unsavedObjectWrappers: Array<ObjectWrapper> = new Array<ObjectWrapper>();
        let unsavedObjects: Array<any> = new Array<any>();
        let objectWrappers: Array<ObjectWrapper> = new Array<ObjectWrapper>();

        this.objectWrappersMap.forEach((objectWrapper: ObjectWrapper, obj_Id: number) => {
            if (objectWrapper.change_Ind != CommonEnums.change_Ind.NO_CHANGE) {
                unsavedObjectWrappers.push(objectWrapper);
            };
        });


        for (let i: number = 0; i < unsavedObjectWrappers.length; i++) {
            let unsavedObjectWrapper = unsavedObjectWrappers[i];

            if (objectWrappers.length == 0) {
                objectWrappers.push(unsavedObjectWrapper);
                continue;
            }

            let foundPriorObjectWrapperIndex = -1;
            for (let j: number = 0; j < objectWrappers.length; j++) {
                if (unsavedObjectWrapper.dependencyLevel < objectWrappers[j].dependencyLevel) {
                    foundPriorObjectWrapperIndex = j;
                    break;
                } else if (unsavedObjectWrapper.dependencyLevel == objectWrappers[j].dependencyLevel) {
                    foundPriorObjectWrapperIndex = j + 1;
                }
            }
            if (foundPriorObjectWrapperIndex != -1)
                objectWrappers.splice(foundPriorObjectWrapperIndex, 0, unsavedObjectWrapper);
            else
                objectWrappers.push(unsavedObjectWrapper);
        }

        for (let i: number = 0; i < objectWrappers.length; i++) {
            unsavedObjects.push(objectWrappers[i].object);
        }
        return unsavedObjects;
    }


}